import { WidgetDisplayTypes } from "src/core/dashboard/api/dashboard.api";

export type SelectedWidgetView = "bar" | "line" | WidgetDisplayTypes.Number | WidgetDisplayTypes.Table;

/**
 * Helper function to get selected widget view.
 * Reformats display type where needed.
 */
const getSelectedWidgetView = (optionsView: WidgetDisplayTypes): SelectedWidgetView => {
  if (optionsView === WidgetDisplayTypes.BarGraph) {
    return "bar";
  }

  if (optionsView === WidgetDisplayTypes.LineGraph) {
    return "line";
  }

  return optionsView;
};

export default getSelectedWidgetView;